<footer class="py-1 footer">
    <div class="container" style="background: black;">
        <p class="m-0 text-center">
            <img [src]=" AssetbasePath + '/Content/MainImages/logo-small.png'" />
        </p>
        <p class="m-0 text-center text-white">
            &copy;{{ currentYear | date:'yyyy' }}  Cone Drive Operations, Inc. All Rights Reserved.
        </p>
        <p class="m-0 text-center text-white">
            888-994-2663&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    
            <img width="28" height="28" alt="" [src]="AssetbasePath + '/Content/MainImages/ico-mail-circle.svg'" />
            <a href="mailto:orders@conedrive.com" class="text-white">orders&#64;conedrive.com</a>
        </p>
        <!-- <input id="hostpath" type="hidden" value="@hostName" /> -->
    </div>
    </footer>